import type { FunctionComponent } from 'react'
import React, { useContext, useRef, useState } from 'react'

import { constructDate } from '../../../../shared/components/DatePicker/formatDate/constructDate'
import { DatePickerPage } from '../../../../shared/pages/DatePickerPage'
import { ToolContext } from '../../../../shared/state/appContext'
import type { DatePickerInputRef } from '../../../../shared/types/toolTypes'
import { cleanText } from '../../../../shared/utils/cleanText'
import { formatToolName } from '../../../../shared/utils/formatToolName'
import { getDatePickerValidationErrorMessage } from '../../../../shared/utils/getDatePickerValidationErrorMessage/getDatePickerValidationErrorMessage'
import { generalDataLayer } from '../../../../shared/utils/tracking'
import { LimitedOptionsFlow, OnFinanceFlow, WhenPurchasedFlow } from '../../pageFlowData'
import { whenPurchasedData } from './data'

export const WhenPurchased: FunctionComponent = () => {
  const { state, dispatch } = useContext(ToolContext)
  const {
    initial: { entryToolName },
    car: { whenPurchased },
  } = state

  const WhenPurchasedInput = useRef<DatePickerInputRef>(null)

  const [datePickerError, setDatePickerError] = useState('')

  /* v8 ignore next */
  const getValue = () => {
    return cleanText(WhenPurchasedInput?.current?.datePickerInput?.value || whenPurchased)
  }

  const handleStepChoice = (value: string) => {
    const dateSixYearsAgo = new Date().getTime() - 2191 * 24 * 60 * 60 * 1000
    if (new Date(value).getTime() > dateSixYearsAgo) {
      return { progress: OnFinanceFlow.PROGRESS_VALUE, step: OnFinanceFlow.STEP }
    }

    return { progress: LimitedOptionsFlow.PROGRESS_VALUE, step: LimitedOptionsFlow.STEP }
  }

  const handleDispatch = (value: string) => {
    const { progress, step } = handleStepChoice(value)

    dispatch({ type: 'UPDATE_WHEN_PURCHASED', data: value })
    dispatch({ type: 'UPDATE_STEP', data: step })
    dispatch({ type: 'UPDATE_PROGRESS_VALUE', data: progress })
  }

  /* v8 ignore next */
  const handleInputChange = (value: string) => {
    /* v8 ignore next */
    dispatch({ type: 'UPDATE_WHEN_PURCHASED', data: value })
  }

  const handleSubmit = () => {
    setDatePickerError('')
    const dateInputValue: string = getValue()
    const errorMessage = getDatePickerValidationErrorMessage(dateInputValue, true)
    /* v8 ignore next */
    if (errorMessage) {
      return setDatePickerError(errorMessage)
    }
    const trackingAnswer = `question | ${WhenPurchasedFlow.VIEW_NAME} | ${dateInputValue}`
    generalDataLayer(formatToolName(entryToolName), trackingAnswer, false)
    handleDispatch(dateInputValue)
  }

  const { title, imgObj } = whenPurchasedData

  return (
    <DatePickerPage
      buttonText="Next"
      handleInputChange={handleInputChange}
      handleSubmit={handleSubmit}
      imgObj={imgObj}
      isFocused
      max={constructDate(new Date(), false)}
      newErrorMessage={datePickerError}
      purchasedDate={whenPurchased}
      ref={WhenPurchasedInput}
      renderError={datePickerError !== ''}
      testId="when-purchased"
      title={title}
    />
  )
}
